import type { Teacher } from '~/service/__generated-api'

export function getTeachersFullnames(teachers: Teacher[]) {
  if (!teachers.length) return '-'

  return teachers.map(teacher => teacher.full_name).join(', ')
}
